<template>
  <div class="lung-sound-check">
    <md-chip class="md-primary">Any lung sound at location</md-chip>
    <md-field>
      <md-select
        v-close-on-zoom
        class="orientation-select"
        :value="state.check.orientation"
        placeholder="any side"
        :disabled="readonly"
        :md-attach-to-parent="true"
        @input="orientation => selectOrientation(orientation)"
      >
        <md-option class="orientation-option">any side</md-option>
        <md-option value="FRONT" class="orientation-option">front</md-option>
        <md-option value="BACK" class="orientation-option">back</md-option>
      </md-select>
      <md-select
        v-close-on-zoom
        class="spot-select"
        :value="state.check.spots"
        placeholder="any spot"
        :multiple="true"
        :disabled="!lungSoundSpots.length || readonly"
        :md-attach-to-parent="true"
        @input="spots => selectSpots(spots)"
      >
        <md-menu-item>
          <md-checkbox v-model="isAnySpot" class="md-primary">Any</md-checkbox>
        </md-menu-item>
        <md-option
          v-for="spot in lungSoundSpots"
          :key="spot"
          :value="spot"
          class="spot-option"
        >
          {{ state.check.orientation === 'BACK' ? spot + 1 + 4 : spot + 1 }}
        </md-option>
      </md-select>
    </md-field>
    <md-chip class="md-primary">is</md-chip>
    <md-field>
      <md-select
        v-close-on-zoom
        class="sound-select"
        :value="state.check.value"
        placeholder="Select a sound"
        :disabled="readonly"
        @input="sound => setValue(sound)"
      >
        <md-option
          v-for="sound in lungSounds"
          :key="sound.id"
          :value="sound.resourceName"
          class="sound-option"
        >
          {{ sound.resourceName }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import range from 'lodash/range';

export default {
  name: 'lung-sound-check',
  components: {},
  props: [
    'sounds',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {
          orientation: null,
          spots: [],
        },
      },
      lungSounds: this.sounds.filter(s => s.category === 'breath'),
    };
  },
  computed: {
    isAnySpot: {
      get() {
        return isEmpty(this.state.check.spots);
      },
      set() {
        this.selectSpots([]);
      },
    },
    lungSoundSpots() {
      const { orientation } = this.state.check;
      if (orientation === 'FRONT') {
        return range(4);
      }
      else if (orientation === 'BACK') {
        return range(6);
      }
      return [];
    },
  },
  created() {
    this.state.check = {
      ...this.state.check,
      ...(this.getData(this.ikey) || {}),
    };
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectSpots(spots) {
      this.state.check.spots = spots;
      this.update();
    },
    selectOrientation(orientation) {
      this.state.check.orientation = orientation;
      // Only keep the applicable spots
      this.state.check.spots = this.state.check.spots.filter(
        spot => this.lungSoundSpots.includes(spot),
      );
      this.update();
    },
    setValue(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'LUNG_SOUND',
        operator: 'EQUAL',
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.lung-sound-check {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
